import { discretoAtivo } from '../discreto';
import type { Som } from './dados';

/**
 * Fase 2 (W3): assinaturas curtas de Web Audio por tipo (sem arquivo de áudio). Só toca com o som ligado na central e
 * NUNCA com o modo discreto ligado (quem oculta valores também não quer chamar atenção).
 */
const NOTAS: Record<Som, number[]> = { entrada: [660, 880], saida: [880, 660], alerta: [740, 740], aviso: [520, 390], padrao: [700] };
let contexto: AudioContext | null = null;

export function podeTocar(somLigado: boolean) {
  return somLigado && !discretoAtivo() && typeof AudioContext !== 'undefined';
}

/** Fase 2 (W16, review r16 robustez M6): numa rajada de avisos, o som toca no máximo uma vez a cada 3 s. */
export const JANELA_SOM_MS = 3_000;
let ultimoSom = -Infinity;

/** Pode tocar agora (fora da janela do último som)? Anota o toque quando sim. */
export function somNaJanela(agora = Date.now()): boolean {
  if (agora - ultimoSom < JANELA_SOM_MS) return false;
  ultimoSom = agora;
  return true;
}

export function tocarSom(som: Som, somLigado: boolean) {
  if (!podeTocar(somLigado) || !somNaJanela()) return;
  try {
    contexto ??= new AudioContext();
    const agora = contexto.currentTime;
    NOTAS[som].forEach((freq, i) => {
      const o = contexto!.createOscillator();
      const g = contexto!.createGain();
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.08, agora + i * 0.14);
      g.gain.exponentialRampToValueAtTime(0.0001, agora + i * 0.14 + 0.12);
      o.connect(g).connect(contexto!.destination);
      o.start(agora + i * 0.14);
      o.stop(agora + i * 0.14 + 0.13);
    });
  } catch {
    /* navegador sem áudio: o aviso visual basta */
  }
}
